import { ArtDecoWhite } from './ArtDecoWhite';

export default ArtDecoWhite;
